import { useState } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useQueryParam } from "../utils/url";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { GoogleLoginButton } from "./GoogleLoginButton";

export const ConnectNewInboxPage = () => {
  const [isConnected, setIsConnected] = useState(false);
  const showLoginOption = !isConnected;
  const code = useQueryParam("code");
  const redirectUrl = useQueryParam("redirectUrl");
  const [loginFailedMessage, setLoginFailedMessage] = useState<string>("");
  const [step, setStep] = useState<1 | 2>(code ? 2 : 1);

  const onLoginSuccess = (redirectUrlFromState: string | null) => {
    setIsConnected(true);
    setLoginFailedMessage("");
    if (redirectUrlFromState) {
      window.location.href = redirectUrlFromState;
    }
  };

  if (isConnected && redirectUrl) {
    window.location.href = redirectUrl;
  }

  return (
    <Container maxWidth={step === 2 ? "md" : "xs"}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Paper
          elevation={3}
          sx={{ padding: 4, textAlign: "center", width: "100%" }}
        >
          {/* Back Button (Only on Step 2) */}
          {step === 2 && (
            <Button
              onClick={() => setStep(1)}
              startIcon={<ArrowBackIcon />}
              sx={{ mb: 2, alignSelf: "flex-start" }}
              size="small"
            >
              Back
            </Button>
          )}

          <Typography variant="h5" fontWeight="bold" mb={2}>
            {isConnected ? "Everything set! 🎉" : "Connect New Inbox"}
          </Typography>

          {loginFailedMessage && (
            <Typography color="error" mb={2}>
              {loginFailedMessage}
            </Typography>
          )}

          {/* Step 1: Start Setup */}
          {showLoginOption && step === 1 && (
            <Box>
              <Box mb={2}>
                <img
                  src="/www/assets/dobby_login_hero.png"
                  alt="Login Hero"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Typography variant="body2" color="textSecondary" mb={2}>
                We will need you to connect your work account and give it the
                necessary permissions.
              </Typography>
              <Button
                variant="contained"
                sx={{ maxWidth: "120px" }}
                color="primary"
                endIcon={<ArrowForwardIosIcon />}
                onClick={() => setStep(2)}
                fullWidth
              >
                Start
              </Button>
            </Box>
          )}

          {/* Step 2: Instructions + Login */}
          {showLoginOption && step === 2 && (
            <Box>
              <Typography variant="body2" color="textSecondary" mb={2}>
                Click on "Continue With Google" button below and follow the
                instructions to set up your account.
              </Typography>
              <Box display="flex" flexDirection="row" sx={{ gap: "4px" }}>
                {/* Box 1- Bypass Google Warning */}
                <Box
                  flex={1}
                  p={2}
                  mb={2}
                  sx={{ backgroundColor: "#eff4f8", borderRadius: 2 }}
                >
                  <Typography fontWeight="bold" mb={1}>
                    Bypass "Google hasn't verified this app"
                  </Typography>
                  <img
                    src="/www/assets/google_unverified_instructions.gif"
                    alt="Google Unverified Instructions"
                    style={{
                      width: "100%",
                      maxHeight: "300px",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                {/* Step 4 - Grant Permissions */}
                <Box
                  flex={1}
                  p={2}
                  mb={2}
                  sx={{ backgroundColor: "#eff4f8", borderRadius: 2 }}
                >
                  <Typography fontWeight="bold" mb={1}>
                    Grant Dobby the necessary permissions
                  </Typography>
                  <img
                    src="/www/assets/google_grant_permission_instructions.gif"
                    alt="Google Grant Permissions"
                    style={{
                      width: "100%",
                      maxHeight: "300px",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Box>

              <Box mt={2}>
                <GoogleLoginButton
                  onLoginStart={() => {}}
                  redirectUrl={redirectUrl}
                  code={code}
                  onSuccess={onLoginSuccess}
                  onFailure={setLoginFailedMessage}
                  connectNewInbox
                />
              </Box>
            </Box>
          )}

          {/* Logged-in View */}
          {isConnected && (
            <>
              <Typography variant="body1" mt={2} mb={2}>
                You connected the new inbox to dobby. Nothing else to do right
                now, thank you!
              </Typography>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
};
